import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const CloseIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        viewBox="0 0 24 24"
        preserveAspectRatio="none"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.128 12.005 23.265 1.87A.801.801 0 1 0 22.13.735L11.994 10.871 1.87.748A.802.802 0 0 0 .735 1.882L10.86 12.005.747 22.12a.802.802 0 0 0 1.133 1.134L11.994 13.14l10.125 10.124a.798.798 0 0 0 1.134 0 .801.801 0 0 0 0-1.134L13.128 12.005Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default CloseIcon;
